import { Component, Input } from '@angular/core';
import { ThingProvider } from '@providers/thing.provider';
import { NotificationService } from '@core/notification/notification.service';
import { RefreshEvent } from '@events/RefreshEvent';
import { ThingsUtil } from '../../../util/things';
import { FormConfig } from '../form/form.component';
import { ThingConfig } from '@core/thing/thingConfig';

@Component({
  selector: 'things-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.less']
})
export class ThingsAddComponent {

  @Input()
  public config: ThingConfig;

  constructor(private thing: ThingProvider, private notification: NotificationService, private refresher: RefreshEvent, private thingsUtil: ThingsUtil) {}

  submit(thing) {
    return new Promise((resolve, reject) => {
      this.thing.addThing(thing).then(res => {
        this.notification.show('success', 'You have successfully added ' + thing.name);
        if (this.thingsUtil.isResource(thing)) {
          this.refresher.fire('resourcesList.refresh');
        } else {
          this.refresher.fire('thingsList.refresh');
        }

        resolve(res);
      }).catch(err => {
        this.notification.show('alert', 'Something went wrong.');
        reject(err);
      });
    });
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/things/add/add.component.ts